import React, { createContext, useContext, useState } from 'react';
import { roleOptions } from '../../constants';

const EditTeamMemberContext = createContext();

export const EditTeamMemberProvider = ({ children, initialUser, initialCompany }) => {
  const [errors, setErrors] = useState([]); // null means no errors
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(initialCompany);
  const [isLoaded, setIsLoaded] = useState(false);
  const [acls, setAcls] = useState([]);
  // Revisit These for Form candidates
  const [user, setUser] = useState(initialUser);
  const [companyRole, setCompanyRole] = useState(roleOptions[0]);
  const [forceMfa, setForceMfa] = useState(false);
  const [oldEmail, setOldEmail] = useState(null);
  const [isDirty, setIsDirty] = useState(false);
  const [companyLevelAcl, setCompanyLevelAcl] = useState(null);
  const [globalAccess, setGlobalAccess] = useState(false);
  const [properties, setProperties] = useState([]);

  return (
    <EditTeamMemberContext.Provider
      value={{
        errors,
        setErrors,
        loading,
        setLoading,
        company,
        setCompany,
        user,
        setUser,
        forceMfa,
        setForceMfa,
        oldEmail,
        setOldEmail,
        isDirty,
        setIsDirty,
        companyLevelAcl,
        setCompanyLevelAcl,
        globalAccess,
        setGlobalAccess,
        properties,
        setProperties,
        companyRole,
        setCompanyRole,
        isLoaded,
        setIsLoaded,
        acls,
        setAcls
      }}
    >
      {children}
    </EditTeamMemberContext.Provider>
  );
};

export const useEditTeamMember = () => {
  const context = useContext(EditTeamMemberContext);
  if (!context) {
    throw new Error('useEditTeamMember must be used within an EditTeamMemberProvider');
  }
  return context;
};
